//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class AttendanceCancelOptions extends ItemBase {
    UserNote: string | null = null;
    ConfirmDeadlineNotPassed: boolean = false;
    ApplyCancellationPolicy: boolean = false;

    constructor(initializer?: Partial<AttendanceCancelOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "AttendanceCancelOptions";
}
